import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { zigbeeOff } from '../../../../actions/zigbee/commands/onoff/ZigbeeOff';
import { useAppDispatch } from '../../../../hooks';
import { zigbeeOn } from '../../../../actions/zigbee/commands/onoff/ZigbeeOn';
import { zigbeeToggle } from '../../../../actions/zigbee/commands/onoff/ZigbeeToggle';
import { zigbeeOffWithEffect, isEffectDelayedAllOffVariant } from '../../../../actions/zigbee/commands/onoff/ZigbeeOffWithEffect';
import { zigbeOnWithRecallGlobalScene } from '../../../../actions/zigbee/commands/onoff/ZigbeeOnWithRecallGlobalScene';
import { zigbeeOnWithTimedOff } from '../../../../actions/zigbee/commands/onoff/ZigbeeOnWithTimedOff';
import { CmdArea } from '../../common/CmdArea';
const On = (props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeOn(props.nid, props.eid));
    };
    return (_jsx(CmdArea, { children: _jsx("button", { onClick: onClick, children: "On" }) }));
};
const Off = (props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeOff(props.nid, props.eid));
    };
    return (_jsx(CmdArea, { children: _jsx("button", { onClick: onClick, children: "Off" }) }));
};
const Toggle = (props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeToggle(props.nid, props.eid));
    };
    return (_jsx(CmdArea, { children: _jsx("button", { onClick: onClick, children: "Toggle" }) }));
};
const OffWithEffect = (props) => {
    const dispatch = useAppDispatch();
    const [effect, setEffect] = useState({ type: 'delayed all off', variant: 'fade to off in 0.8 seconds' });
    const onClick = () => {
        dispatch(zigbeeOffWithEffect(props.nid, props.eid, effect));
    };
    const effectChange = e => {
        switch (e.target.value) {
            case 'delayed all off':
                setEffect({ type: 'delayed all off', variant: 'fade to off in 0.8 seconds' });
                break;
            case 'dying light':
                setEffect({ type: 'dying light', variant: '20% dim up in 0.5s then fade to off in 1 second' });
                break;
        }
    };
    const variantEffectDelayedAllOffChange = e => {
        if (isEffectDelayedAllOffVariant(e.target.value)) {
            setEffect({ type: 'delayed all off', variant: e.target.value });
        }
    };
    let variant;
    switch (effect.type) {
        case 'delayed all off':
            variant = (_jsxs("select", { value: effect.variant, style: { width: '20em' }, onChange: variantEffectDelayedAllOffChange, children: [_jsx("option", { value: 'fade to off in 0.8 seconds', children: "fade to off in 0.8 seconds" }), _jsx("option", { value: 'no fade', children: "no fade" }), _jsx("option", { value: '50% dim down in 0.8 seconds then fade to off in 12 seconds', children: "50% dim down in 0.8 seconds then fade to off in 12 seconds" })] }));
            break;
    }
    return (_jsxs(CmdArea, { children: [_jsxs("select", { value: effect.type, onChange: effectChange, children: [_jsx("option", { value: 'EffectDelayedAllOff', children: "Delayed all off" }), _jsx("option", { value: 'EffectDyingLight', children: "Dying light" })] }), _jsx("br", {}), variant, _jsx("br", {}), _jsx("button", { onClick: onClick, children: "Off with effect" })] }));
};
const OnWithRecallGlobalScene = (props) => {
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeOnWithRecallGlobalScene(props.nid, props.eid));
    };
    return (_jsx(CmdArea, { children: _jsx("button", { onClick: onClick, children: "On with recall global scene" }) }));
};
const CmdOnWithTimedOff = (props) => {
    const [onWithTimedOff, setOnWithTimedOff] = useState({ acceptOnlyWhenOn: false, onTime: 0, offWaitTime: 0 });
    const dispatch = useAppDispatch();
    const onClick = () => {
        dispatch(zigbeeOnWithTimedOff(props.nid, props.eid, onWithTimedOff));
    };
    const handleAcceptOnlyWhenOn = e => {
        setOnWithTimedOff(Object.assign(Object.assign({}, onWithTimedOff), { acceptOnlyWhenOn: e.target.checked }));
    };
    const handleOnTime = e => {
        setOnWithTimedOff(Object.assign(Object.assign({}, onWithTimedOff), { onTime: parseInt(e.target.value) }));
    };
    const handleOffWaitTime = e => {
        setOnWithTimedOff(Object.assign(Object.assign({}, onWithTimedOff), { offWaitTime: parseInt(e.target.value) }));
    };
    return (_jsxs(CmdArea, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: onWithTimedOff.acceptOnlyWhenOn, onChange: handleAcceptOnlyWhenOn }), " Accept Only When On"] }), _jsx("br", {}), _jsxs("label", { children: ["On Time ", _jsx("input", { type: "number", size: 6, value: onWithTimedOff.onTime, onChange: handleOnTime })] }), _jsx("br", {}), _jsxs("label", { children: ["Off Wait Time ", _jsx("input", { type: "number", size: 6, value: onWithTimedOff.offWaitTime, onChange: handleOffWaitTime })] }), _jsx("br", {}), _jsx("button", { onClick: onClick, children: "On with timed off" })] }));
};
export const CommandsOnOff = props => {
    return (_jsx(React.Fragment, { children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '1em' }, children: [_jsx(On, Object.assign({}, props)), _jsx(Off, Object.assign({}, props)), _jsx(Toggle, Object.assign({}, props)), _jsx(OffWithEffect, Object.assign({}, props)), _jsx(OnWithRecallGlobalScene, Object.assign({}, props)), _jsx(CmdOnWithTimedOff, Object.assign({}, props))] }) }));
};
